import React from 'react';
import { STORE_TYPE } from '../../../common/types/types';
import { AnnotationDetails, SelectAnnotationCheckbox, ShowHideButton } from '../annotation-details';
import { useShowHideHandler } from '../annotation-details/hooks/use-show-hide-handler';
import type { AnnotationInfoT } from '../annotations/types';
type PropsT = {
  annotation: AnnotationInfoT;
  icon: React.ReactNode;
  isFocused: boolean;
  checkedAnnotationIds: string[];
  handleCheckAnnotation: (id: string) => void;
};
export function AnnotationDetailItem({
  annotation,
  icon,
  isFocused,
  checkedAnnotationIds,
  handleCheckAnnotation
}: PropsT) {
  const {
    handleShowHideAnnotation
  } = useShowHideHandler({
    annotation,
    storeType: STORE_TYPE.ML_ANNOTATION_STORE
  });
  return <AnnotationDetails annotation={annotation} icon={icon} isFocused={isFocused} selectAnnotationCheckbox={annotation => <SelectAnnotationCheckbox annotation={annotation} isChecked={checkedAnnotationIds.includes(annotation.id)} onCheck={handleCheckAnnotation} />} showHideButton={annotation => <ShowHideButton annotation={annotation} onClick={handleShowHideAnnotation} />} />;
}